import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { UtilsService } from 'app/modules/utils-service';
import { forkJoin, Observable } from 'rxjs';
import { RegistroBienCulturalService } from './registro-bien-cultural.service';


@Injectable({ providedIn: 'root' })
export class RegistroBienCulturalResolver implements Resolve<any> {
    constructor(private registroBienService:RegistroBienCulturalService){}

    resolve(route: ActivatedRouteSnapshot): Observable<any>  {

        const seccion_uuid =route.paramMap.get('seccion_uuid');
        this.registroBienService.seccion_uuid = isNaN(parseInt(seccion_uuid)) ? 0 : parseInt(seccion_uuid);
        const params = {seccion: seccion_uuid}

        return forkJoin([
            this.registroBienService.getColeccionistas(params)
        ])
    }
}